/** Business-web redesign cutover: the banner hides and the api force-on job flips remaining shops from here on. */
export const REDESIGN_CUTOVER_AT = new Date('2026-11-02T11:00:00.000Z');
